import {ChatUI} from "./ChatUI.js";
import {Chats} from "./Chats.js";
import {chatClientState} from "./ChatClientState.js";

export class Debaters extends ChatUI {
	/**
	 * @param {ChatClient} client - parent client
	 * @param {jQuery} header
	 * @param {jQuery} main - element which will be container of the widget
	 * @param {jQuery} footer
	 * @param {string} me - ID of the current user
	 */
	constructor(client, header, main, footer, me) {
		super();
		this.client = client;
		this.header = header;
		this.container = main;
		this.footer = footer;
		this.me = me;
		this.debaters = [];
		this.selected = new Set();
		this.install();
	}

	install() {
		this.debatersListContainer = $("<div class='chat-list'></div>");
		this.container.append(this.debatersListContainer);

		this.debatersListControls =$("<div class='chat-controls'></div>");
		this.footer.append(this.debatersListControls);

		this.headerTitle = $("<span class='chat-header-title'></span>");
		this.headerTitle.text(bundle.get("chat.debater.select"));
		this.header.append(this.headerTitle);

		this.topicInput = $("<input type='text' maxlength='128' class='width100p' style='margin-bottom: 4px;display:none'>");
		this.topicInput.attr("placeholder", bundle.get("chat.topic"));
		this.debatersListControls.append(this.topicInput);

		const r = $("<div class='chat-controls-row'></div>");
		this.debatersListControls.append(r);

		this.createButton = $("<button class='fbutton' disabled></button>");
		this.createButton.text(bundle.get("button.createChat").replace("{0}", "0"));
		r.append(this.createButton);
		this.createButton.on("click", this.createAction.bind(this));

		this.cancelButton = $("<button class='fbutton' style='margin-left:16px'></button>");
		this.cancelButton.text(bundle.get("bas.cancel"));
		r.append(this.cancelButton);
		this.cancelButton.on("click", this.cancelAction.bind(this));

		this.reload();
	}

	createAction() {
		let url = "api/messaging/chats/create";
		url += "?topic=" + encodeURIComponent(this.topicInput.val());
		let debs = this.me;
		this.selected.forEach(value => { debs = debs +","+ value; })
		url += "&debaters=" + encodeURIComponent(debs);
		$.getJSON(url)
			.done((chat) => {
				this.fireEvent("created", chat);
			});
	}

	cancelAction() {
		this.fireEvent("cancel", {});
	}

	reload() {
		const d = chatClientState.data;
		if (d == null) {
			$.getJSON("api/messaging/debaters")
				.done((data) => {
					this.displayDebaters(data);
					chatClientState.data = data;
				});
		} else {
			this.displayDebaters(d);
		}
	}

	displayDebaters(data) {
		this.debaters = data;
		this.debatersListContainer.empty();
		for (let db of this.debaters) {

			if (this.me === db.nick) continue;

			const debContainer = Chats.chatListItem(db.name, "@" + db.nick, [ db ], 0);
			debContainer.attr("data-handler", db.nick);

			this.debatersListContainer.append(debContainer);
			debContainer.on("click", this.debaterToggle.bind(this, db.nick));
		}
	}

	debaterToggle(handle) {
		let listItem = this.debatersListContainer.find("[data-handler=" + handle + "]");
		if (this.selected.has(handle)) {
			// Remove
			listItem.removeClass("selected");
			this.selected.delete(handle);
		} else {
			// Add
			listItem.addClass("selected");
			this.selected.add(handle);
		}
		this.enableButton();
	}

	enableButton() {
		if (this.selected.size > 0) {
			this.createButton.text(bundle.get("button.createChat").replace("{0}", (this.selected.size).toString()));
			this.createButton.prop("disabled", false);
		} else {
			this.createButton.text(bundle.get("button.createChat").replace("{0}", "0"));
			this.createButton.prop("disabled", true);
		}
		if (this.selected.size > 1) this.topicInput.show();
		else this.topicInput.hide();
	}


	debaterStateChanged(handle, state) {
		super.debaterStateChanged(handle, state);
		// Update data structure
		let wasChange = false;
		for (let db of this.debaters) {
			if (db.nick === handle) {
				db.state = state;
				wasChange = true;
				break;
			}
		}
		Chats.setStateClass(this.debatersListContainer, handle, state);
		if (wasChange) chatClientState.data = this.debaters;
	}
}
